var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBrushDark({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_574_6685)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8.22754 1.5H6.72754C2.97754 1.5 1.47754 3 1.47754 6.75V11.25C1.47754 15 2.97754 16.5 6.72754 16.5H11.2275C14.9775 16.5 16.4775 15 16.4775 11.25V9.75",
    stroke: "#FFFFFF",
    strokeWidth: 1.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.4101 2.67017C15.4876 4.97267 13.1701 8.10767 11.2351 9.66017L10.0501 10.6052C9.90008 10.7177 9.75008 10.8077 9.57758 10.8752C9.57758 10.7627 9.57008 10.6502 9.55508 10.5302C9.48758 10.0277 9.26258 9.55517 8.85758 9.15767C8.44508 8.74517 7.95008 8.51267 7.44008 8.44517C7.32008 8.43767 7.20008 8.43017 7.08008 8.43767C7.14758 8.25017 7.24508 8.07767 7.37258 7.93517L8.31758 6.75017C9.87008 4.81517 13.0126 2.48267 15.3076 1.56017C15.6601 1.42517 16.0051 1.53017 16.2226 1.74767C16.4476 1.97267 16.5526 2.31767 16.4101 2.67017Z",
    stroke: "#FFFFFF",
    strokeWidth: 1.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.58507 10.8683C9.58507 11.5283 9.33007 12.1583 8.85757 12.6383C8.49007 13.0058 7.99507 13.2608 7.40257 13.3358L5.92507 13.4933C5.12257 13.5833 4.43257 12.9008 4.52257 12.0833L4.68007 10.6058C4.82257 9.29334 5.91757 8.45334 7.08757 8.43084C7.20757 8.42334 7.32757 8.43084 7.44757 8.43834C7.95757 8.50584 8.45257 8.73834 8.86507 9.15084C9.27007 9.55584 9.49507 10.0208 9.56257 10.5233C9.57757 10.6433 9.58507 10.7633 9.58507 10.8683Z",
    stroke: "#FFFFFF",
    strokeWidth: 1.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.865 8.98508C11.865 7.41758 10.5975 6.14258 9.02246 6.14258",
    stroke: "#FFFFFF",
    strokeWidth: 1.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_574_6685"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 18,
    height: 18,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBrushDark);
export default __webpack_public_path__ + "static/media/brush-dark.5629e03237a56763f09577a8f5283326.svg";
export { ForwardRef as ReactComponent };